import { render, staticRenderFns } from "./AstraTopElementTacticKpiTableColumn.vue?vue&type=template&id=60471e06&scoped=true"
import script from "./AstraTopElementTacticKpiTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementTacticKpiTableColumn.vue?vue&type=script&lang=js"
import style0 from "./AstraTopElementTacticKpiTableColumn.vue?vue&type=style&index=0&id=60471e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60471e06",
  null
  
)

export default component.exports